import styled from 'styled-components';

export const ButtonBlock = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px 0;
  width: 100%;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DetailTitle = styled.h1`
  border-bottom: 1px solid #F0F0F0;
  font-size: 24px;                                            
  padding: 0 0 5px 0;                 
`;

export const DetailFlowContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 0 20px 30px 20px;
  width: 100%;
`;

export const DetailBlockItemRed = styled.div `
  align-items: center;
  background: #FFFFFF;
  border-radius: 50%;
  border: 10px solid rgb(255, 64, 99);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 155px;
  padding: 15px;
  width: 155px;
`;

export const DetailBlockItemBlue = styled.div `
  align-items: center;
  background: #FFFFFF;
  border-radius: 50%;
  border: 10px solid rgb(60, 150, 211);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 155px;
  padding: 15px;
  width: 155px;
`;

export const DetailBlockItemGreen = styled.div `
  align-items: center;
  background: #FFFFFF;
  border-radius: 50%;
  border: 10px solid rgb(77, 147, 96);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 155px;
  padding: 15px;
  width: 155px;
`;


export const DetailBlockItemTitle = styled.p`
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  width: 100%;
`;

export const DetailBlockItemDate = styled.p`
  font-size: 12px;
  text-align: center;
  width: 100%;
`;

export const DetailBlockItemDescription = styled.p`
  font-size: 12px;
  padding: 10px 0 0;
  text-align: center;
  width: 100%;
`;

export const DetailBlockItemImg = styled.img`
 height: 35px;
 width: 35px;
`;

export const FlowDetailBlock = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 165px;
  justify-content: center;
  padding: 0 20px;
  width:40px;
`;

export const FlowDetailBlockImg = styled.img`
  width: 20px;
  transform: rotate(-90deg);
`;

export const TabsContentTitle = styled.h3`
  box-sizing: border-box;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  padding: 20px 10px 10px 10px;
`; 
 

export const TabsContentDescription = styled.p`
  box-sizing: border-box;
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  padding: 0 10px;
`; 